import { type SagaIterator } from '@redux-saga/core';
import { call, put, takeEvery } from 'redux-saga/effects';
import {getNotifications, addReadStatusNotifications } from '../../services/notifications/notification.api'
import { NotificationGetPayload, NotificationReadStatusPayload, type NotificationDetails} from '../../types/notifications';
import { notificationActions } from './slice';
import { PayloadAction } from '@reduxjs/toolkit';

// Worker Sagas
export function* onGetNotifications(
  action: PayloadAction<NotificationGetPayload>
): SagaIterator {
    try {
        const notificationHistories: NotificationDetails[] = yield call(getNotifications, action.payload);
        yield put(notificationActions.fetchAllSucceeded(notificationHistories));
    } catch (e: unknown) {
        if (e instanceof Error) {
            yield put(notificationActions.fetchAllFailure(e.message.toString()));
        }
    }
}

function* AddReadStatusSaga(action: PayloadAction<NotificationReadStatusPayload>) {
  try {
    const response: string = yield call(addReadStatusNotifications, action.payload);
    yield put(notificationActions.AddReadStatusSucceeded(response));
  } catch (error: any) {
    yield put(notificationActions.AddReadStatusFailure(error.message));
  }
}

// Watcher Saga
function* notificationWatcherSaga(): SagaIterator {
    yield takeEvery(notificationActions.fetchAll.type, onGetNotifications);
}

function* AddReadStatusWatcherSaga(): SagaIterator {
  yield takeEvery(notificationActions.AddReadStatusRequest.type, AddReadStatusSaga);
}

export { notificationWatcherSaga, AddReadStatusWatcherSaga};